import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { router } from './router';
import { queryClient } from './lib/queryClient';
import { applyThemeEarly } from './lib/theme';
import { I18nRoot } from './lib/i18n';
import './styles.css';

applyThemeEarly();

const root = document.getElementById('root');
if (!root) throw new Error('#root missing');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <I18nRoot>
        <RouterProvider router={router} />
      </I18nRoot>
    </QueryClientProvider>
  </StrictMode>,
);
